import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import App from '@/App.vue'
import router from '@/routers/index'
import vuex from '@/store/index'
// eslint-disable-next-line import/no-named-as-default
import Notifications from '@kyvg/vue3-notification'
import VTooltipPlugin from 'v-tooltip'
import VueTheMask from 'vue-the-mask'
import VueGtag from 'vue-gtag'
import PrimeVue from 'primevue/config';
import Wind from '@/presets/wind';      //import preset        
import DialogService from 'primevue/dialogservice';
import ConfirmationService from 'primevue/confirmationservice'
import * as Sentry from "@sentry/vue";

import '@/plugins/axios'
import '@/plugins/vee-validation'
import { Unicon } from '@/plugins/Unicons'

import 'animate.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/helpers.scss'
import '@/assets/css/base.css'
import '@/assets/css/notifications.scss'
import 'v-tooltip/dist/v-tooltip.css'
import '@/assets/css/primevue-custom.css'

import ToastService from 'primevue/toastservice';

const pinia = createPinia()
pinia.use(({ store }) => {
    store.$router = markRaw(router)
})

const app = createApp(App)

const gTag = import.meta.env.VITE_APP_GTAG_ID

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            networkDetailAllowUrls: [
                /^https:\/\/([a-z0-9-]+\.)?chatmix\.com\.br/,
            ],
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  
app
    .use(VueGtag, { config: { id: gTag } })
    .use(Notifications, { componentName: 'AlertNotification', duration: 700000 })
    .use(router)
    .use(pinia)
    .use(vuex)
    .use(Unicon, { fill: 'currentColor' })
    .use(VueTheMask)
    .use(VTooltipPlugin, { themes: { tooltip: { delay: { show: 0, hide: 150 } } } })
    .use(DialogService)
    .use(ConfirmationService)
    .use(ToastService)
    .use(PrimeVue, {
        unstyled: false,
        pt: Wind,
        locale: {
            dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
            dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
            monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            today: 'Hoje',
            clear: 'Limpar',
            weekHeader: 'Sm',
            firstDayOfWeek: 0, // 0 para Domingo, 1 para Segunda
            dateFormat: 'dd/mm/yy', // Formato de data brasileiro
            weak: 'Fraco',
            medium: 'Médio',
            strong: 'Forte',
            passwordPrompt: 'Digite uma senha',
            aria: {
                star: '{star} estrela',
                stars: '{star} estrelas',
                selectAll: 'Selecionar todos',
                unselectAll: 'Desmarcar todos',
                close: 'Fechar',
                previous: 'Anterior',
                next: 'Próximo',
                navigation: 'Navegação',
                scrollTop: 'Rolar para o topo',
                moveUp: 'Mover para cima',
                moveTop: 'Mover para o topo',
                moveDown: 'Mover para baixo',
                moveBottom: 'Mover para o final',
                moveToTarget: 'Mover para o destino',
                moveToSource: 'Mover para a origem',
                moveAllToTarget: 'Mover tudo para o destino',
                moveAllToSource: 'Mover tudo para a origem',
                pageLabel: 'Página {page}',
                firstPageLabel: 'Primeira página',
                lastPageLabel: 'Última página',
                nextPageLabel: 'Próxima página',
                prevPageLabel: 'Página anterior',
                rowsPerPageLabel: 'Linhas por página',
                trueLabel: 'Verdadeiro',
                falseLabel: 'Falso',
                nullLabel: 'Não selecionado'
            }
        }                            //apply preset        
    })
    .mount('#app')
